import flash from "../../../functions/flash";
import firebase from "firebase";

const updatePoi = async (userRef, status, firstName) => {
  try {
    await firebase.database().ref("poi").child(userRef).update({
      status: status,
    });
    flash(
      `${firstName}'s Proof of Insurance has been updated successfully`,
      "success"
    );
  } catch (e) {
    flash(e.message, "danger");
  }
};

export default updatePoi;
